import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

// Users reads & CRUD migrated to FastAPI (FCA-6861 / FCA-6762). Gated by the
// `migrate_users_permissions` FME flag: fail-safe OFF => Ruby gateway.
// Endpoint paths are identical on both backends, so only the client swaps.
const usersClient = () => (isEnabled("migrate_users_permissions") ? fcaFastApi : fcaGateWay);

export const getUsers = params => usersClient().get(serviceEndpoints.usersEndPoints.getAllUsers, { params });
export const addUser = params => usersClient().post(serviceEndpoints.usersEndPoints.addUser, params);
export const updateUser = (params, id) => usersClient().patch(`${serviceEndpoints.usersEndPoints.updateUser}/${id}`, params);
export const deleteUser = id => usersClient().delete(`${serviceEndpoints.usersEndPoints.deleteUser}/${id}`);
export const getUserById = id => usersClient().get(`${serviceEndpoints.usersEndPoints.getUserById}/${id}`);
export const getListForCommonFilter = params =>
    usersClient().get(`${serviceEndpoints.usersEndPoints.getListForCommonFilter}/get_list`, {
        params
    });
export const getAllUserLogs = (id, params) => {
    return usersClient().get(`${serviceEndpoints.usersEndPoints.getAllUserLogs}/${id}/logs`, { params });
};
export const restoreUserLog = id => fcaGateWay.patch(`${serviceEndpoints.usersEndPoints.restoreUserLog}/${id}/restore`);
export const deleteUserLog = id => fcaGateWay.delete(`${serviceEndpoints.usersEndPoints.deleteUserLog}/${id}`);
export const exportUser = params =>
    fcaGateWay.get(`${serviceEndpoints.usersEndPoints.exportUser}/export_xl`, { method: "GET", responseType: "blob", params });
export const getAllProjectsDropdown = params =>
    fcaGateWay.get(`${serviceEndpoints.usersEndPoints.getAllProjectsDropdown}/projects_dropdown`, { params });
export const getAllBuildingsDropdown = params =>
    fcaGateWay.get(`${serviceEndpoints.usersEndPoints.getAllBuildingsDropdown}/buildings_dropdown`, { params });
export const getAllRolesDropdown = () => fcaGateWay.get(`${serviceEndpoints.usersEndPoints.getAllRolesDropdown}/roles_dropdown`);
export const getAllGroupsDropdown = params => fcaGateWay.get(`${serviceEndpoints.usersEndPoints.getUserPermissions}/user_templates_dropdown`, { params });
export const getConsultanciesBasedOnRole = () =>
    fcaGateWay.get(`${serviceEndpoints.usersEndPoints.getConsultanciesBasedOnRole}/consultancies_dropdown`);
export const getClientsBasedOnRole = params => fcaGateWay.get(`${serviceEndpoints.usersEndPoints.getClientsBasedOnRole}`, { params });
export const updateUserGeneralReviewer = (params, id) =>
    fcaGateWay.patch(`${serviceEndpoints.usersEndPoints.updateUser}/${id}/general_reviewer`, params);

export const uploadUserExcelData = params => fcaReportGateway.post(serviceEndpoints.usersEndPoints.uploadExcelUser, params);

export const downloadUserTemplate = params => fcaReportGateway.get(serviceEndpoints.usersEndPoints.templateDownload, { params });

export const sendResetMailToUsers = () => fcaReportGateway.get(serviceEndpoints.usersEndPoints.sendResetPasswordMail);

export const lockUnlockUser = params => fcaFastApi.post(serviceEndpoints.usersEndPoints.lockUnlockUser, params);
